export default __webpack_public_path__ + "static/media/2-1.bef76c5e.png";